import React, {useState, useEffect, Fragment} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import {useNavigate, useSearchParams} from 'react-router-dom'
import useServices from '../../../../utils/hooks/useServices'
import {ProfileHeader} from '../ProfileHeader'
import MasterServices from '../../../../services/master'
import CompanyServices from '../../../../services/company'
import './Overview.css'
import {PageTitle} from '_metronic/layout/core'
import Contains from 'utils/helpers/Contains'

export function OverviewCompany() {
  const [searchParams] = useSearchParams()
  const [role, setRole] = useState<any>(localStorage.getItem('role') || null)
  const navigate = useNavigate()
  const [data] = useServices(
    searchParams.get('company') ? CompanyServices.showCompany : MasterServices.getCompanyProfile,
    searchParams.get('company')
  )
  const [company, setCompany] = useState<any>({})

  useEffect(() => {
    setRole(localStorage.getItem('role'))
    if (data) {
      setCompany(data?.data)
    }
  }, [data])
  return (
    <Fragment>
      {/* <Button className='btn-sm mb-8' onClick={() => navigate('/all-company')}>
        Kembali
      </Button> */}
      <div className=''>
        {Contains('Alumni Company company', [role]) ? (
          <PageTitle
            breadcrumbs={[
              {
                title: 'Dashboard',
                path: '/dashboard',
                isSeparator: false,
                isActive: false,
              },
              {
                title: '/',
                path: '',
                isSeparator: false,
                isActive: false,
              },
              {
                title: localStorage.getItem('role') === 'Alumni' ? 'Cari Perusahaan' : 'Informasi',
                path: localStorage.getItem('role') === 'Alumni' ? '/company-search' : '#!',
                isSeparator: false,
                isActive: false,
              },
              {
                title: '/',
                path: '',
                isSeparator: false,
                isActive: false,
              },
            ]}
          >
            {company?.companies_name}
          </PageTitle>
        ) : (
          <Button onClick={() => navigate(-1)} className='btn-sm mb-8' style={{padding: '4px'}}>
            <i className='bi bi-arrow-left fs-1'></i>
          </Button>
        )}
        {/* {role != 'Company' && (
          <Button onClick={() => navigate(-1)} className='btn-sm mb-8' style={{padding: '4px'}}>
            <i className='bi bi-arrow-left fs-1'></i>wow
          </Button>
        )} */}
        <ProfileHeader />
        <h4>Informasi</h4>
        <div className='row mt-8'>
          <div className='col-md-12 mb-8'>
            <div className='card-custom'>
              <h6>Tentang Perusahaan</h6>
              <br />
              <p>{company?.companies_overview || '-'}</p>
            </div>
          </div>
          <div className='col-md-6 mb-8'>
            <div className='card-custom'>
              <h6 className='mb-6'>Detail</h6>
              <Row>
                <Col md={6} className='mb-4'>
                  <span>Kepemilikan </span>
                </Col>
                <Col md={6} className='mb-4'>
                  <span className='fw-bold'>
                    {company?.company_ownership?.company_ownerships_name}
                  </span>
                </Col>
                <Col md={6} className='mb-4'>
                  <span>Tahun Berdiri </span>
                </Col>
                <Col md={6} className='mb-4'>
                  <span className='fw-bold'>{company?.companies_year_founded || '-'}</span>
                </Col>
                <Col md={6} className='mb-4'>
                  <span>Jumlah Karyawaan </span>
                </Col>
                <Col md={6} className='mb-4'>
                  <span className='fw-bold'>{company?.company_size?.company_sizes_name} Orang</span>
                </Col>
                <Col md={6} className='mb-4'>
                  <span>Lainnya </span>
                </Col>
                <Col md={6} className='mb-4'>
                  <span className='fw-bold'>{company?.industry?.industries_name || '-'}</span>
                </Col>
                <Col md={6} className='mb-4'>
                  <span>Alamat Website </span>
                </Col>
                <Col md={6} className='mb-4'>
                  {company?.companies_website ? (
                    <a href={company?.companies_website} target='_blank'>
                      Website Perusahaan
                    </a>
                  ) : null}
                </Col>
                <Col md={6} className='mb-4'>
                  <span>Video Profil Perusahaan </span>
                </Col>
                <Col md={6} className='mb-4'>
                  {company?.companies_link_video_profile ? (
                    <a href={company?.companies_link_video_profile} target='_blank'>
                      Video Profil
                    </a>
                  ) : null}
                </Col>
              </Row>
            </div>
          </div>
          <div className='col-md-6 col-xs-12 mb-8'>
            <div className='card-custom'>
              <h6 className='mb-6'>Informasi Kontak</h6>
              <div className='row'>
                <div className='col-md-4 mb-4' style={{fontSize: '14px'}}>
                  Email
                </div>
                <div className='col-md-8 fw-bold mb-4'>{company?.companies_email || '-'}</div>
                <div className='col-md-4 mb-4' style={{fontSize: '14px'}}>
                  Telepon
                </div>
                <div className='col-md-6 fw-bold mb-4'>{company?.companies_phone}</div>
                <div className='col-md-4 mb-4' style={{fontSize: '14px'}}>
                  Alamat
                </div>
                <div className='col-md-8 fw-bold mb-4'>{company?.companies_address || '-'}</div>
                <div className='col-md-4 mb-4' style={{fontSize: '14px'}}>
                  Kode POS
                </div>
                <div className='col-md-8 fw-bold mb-4'>{company?.companies_postal_code || '-'}</div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-xs-12'>
            <div className='card-custom'>
              <h6 className='mb-6'>Informasi PIC</h6>
              <div className='row'>
                <div className='col-md-4 mb-4' style={{fontSize: '14px'}}>
                  Nama PIC
                </div>
                <div className='col-md-8 fw-bold'>{company?.companies_pic}</div>
                <div className='col-md-4 mb-4' style={{fontSize: '14px'}}>
                  Posisi
                </div>
                <div className='col-md-8 fw-bold mb-4'>
                  {company?.companies_pic_position || '-'}
                </div>
                <div className='col-md-4' style={{fontSize: '14px'}}>
                  Email
                </div>
                <div className='col-md-8 fw-bold'>{company?.companies_pic_email || '-'}</div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </Fragment>
  )
}
